import { Component, OnInit } from '@angular/core';
import {FormBuilder, FormGroup, Validators} from "@angular/forms";
import {PageHeaderDataService} from "../../../../../shared/services/page-header-data.service";
import {DatePipe, DecimalPipe} from "@angular/common";
import {Fraccionamiento} from "../../../../../_models/fraccionamiento";
import {Formularios} from "../../../../../_helpers/clases/formularios";
import {Router} from "@angular/router";
import {MatDialog} from "@angular/material/dialog";
import {NotificacionesService} from "../../../../../_app_services/notificaciones.service";
import {FraccionamientoService} from "../fraccionamiento.service";
import {PageHeaderData} from "../../../../../shared/components/forms-header/page-header-data";
import {SolicitudCreditoEstado} from "../../../../../_models/solicitud-credito-estado";
import {SolicitudCreditoService} from "../../../solicitud-credito/solicitud-credito.service";
import {SolicitudCreditoEstadoService} from "../../../../procesadora/solicitud-credito-estado/solicitud-credito-estado.service";

@Component({
  selector: 'app-form-fraccionamiento',
  templateUrl: './form-fraccionamiento.component.html',
  styleUrls: ['./form-fraccionamiento.component.scss']
})
export class FormFraccionamientoComponent extends Formularios<Fraccionamiento> implements OnInit {
  estadoSolicitudParent: SolicitudCreditoEstado= new SolicitudCreditoEstado();
  edit:boolean;
  constructor(
    public router: Router,
    public dialog: MatDialog,
    private fb: FormBuilder,
    public notificacionService: NotificacionesService,
    public service: FraccionamientoService,
    public serviceEstadoSolicitud: SolicitudCreditoEstadoService,
    private headerDataService: PageHeaderDataService,
    private datePipe: DatePipe,
    private decimalPipe: DecimalPipe,
  ) {
    super(router, dialog, 'procesadora/fraccionamiento', service, notificacionService);
  }

  ngOnInit(): void {
    super.ngOnInit();
    this.edit = super.editar;
    super.formularioAbs = this.construirFormGroup();
    if (super.editar) {
      super.formularioAbs.setValue(this.service.getItem());
      this.estadoSolicitudParent = this.f.estadoSolicitud.value;
    } else {
      this.service.restartItem();
    }
    this.headerDataService.setHeaderData(new PageHeaderData('Fraccionamiento', this.rutaPadre, true));
  }

  construirFormGroup(): FormGroup {
    return this.fb.group({
      id: [null],
      cliente: [{value: '', disabled: true}],
      nombre: [{value: '', disabled: true}],
      apellido: [{value: '', disabled: true}],
      codigoCliente: [{value:  '', disabled: true}],
      comercio: [{value:'', disabled: true}],
      estadoSolicitud: [new SolicitudCreditoEstado()],
      numeroSolicitud: [{value:  '', disabled: true}],
      montoSolicitado: [{value: null, disabled: this.dis}],
      plazoMeses: [{value:  '', disabled: this.dis}],
      importeCuota: [{value:  '', disabled: this.dis}],
      mensajeAprobadoRechazado: [{value:'', disabled: this.dis}],
      montoDesembolsado: [{value:  '', disabled: this.dis}],
      fechaSolicitud: [{value: '', disabled: true}],
      colorEstadoSolicitud:[{value: '', disabled: this.dis}],
    });
  }


  guardar(): void {
    this.submitted = true;
    if (!this.formularioAbs.valid) {
      this.submitted = false;
      return;
    }

    this.item = this.formularioAbs.value;
    console.log(this.item.estadoSolicitud)
    const data = {
      id: this.item.id,
      montoSolicitado:this.item.montoSolicitado,
      PlazoMeses: this.item.plazoMeses,
      ImporteCuota: this.item.importeCuota,
      montoDesembolsado: this.item.montoDesembolsado,
      estadoSolicitud: this.item.estadoSolicitud.id
    };
    if (this.editar) {
      this.service.modificarSolicitud(data.id, data).subscribe(
        () => {
          this.notificacionesService.success('Datos Gaurdados.');
          this.router.navigate([`/${this.rutaPadre}`]);
        },
        () => (this.submitted = false),
        () => (this.submitted = false)
      );
    };
  }

  llegaSolicitudCreditoEstado($event: SolicitudCreditoEstado) {
    this.estadoSolicitudParent= $event;
  }

}
